import {
  FETCH_QUESTIONS,
  FETCH_QUESTIONS_SUCCESS,
  FETCH_QUESTIONS_FAILURE,
  FETCH_QUESTION,
  FETCH_QUESTION_SUCCESS,
  FETCH_QUESTION_FAILURE,
  CREATE_QUESTION,
  CREATE_QUESTION_SUCCESS,
  CREATE_QUESTION_FAILURE,
  UPDATE_QUESTION,
  UPDATE_QUESTION_SUCCESS,
  UPDATE_QUESTION_FAILURE,
  DELETE_QUESTION,
  DELETE_QUESTION_SUCCESS,
  DELETE_QUESTION_FAILURE,
  UPLOAD_QUESTIONS,
  UPLOAD_QUESTIONS_SUCCESS,
  UPLOAD_QUESTIONS_FAILURE,
  RESET_QUESTION,
  COUNT_QUESTIONS,
  COUNT_QUESTIONS_SUCCESS,
  COUNT_QUESTIONS_FAILURE,
} from "./actionTypes";

// Fetch Questions
export const fetchQuestions = () => ({
  type: FETCH_QUESTIONS,
});

export const fetchQuestionsSuccess = (questions) => ({
  type: FETCH_QUESTIONS_SUCCESS,
  payload: questions,
});

export const fetchQuestionsFailure = (error) => ({
  type: FETCH_QUESTIONS_FAILURE,
  payload: error,
});

// Fetch Question
export const fetchQuestion = (questionId) => ({
  type: FETCH_QUESTION,
  payload: questionId,
});

export const fetchQuestionSuccess = (question) => ({
  type: FETCH_QUESTION_SUCCESS,
  payload: question,
});

export const fetchQuestionFailure = (error) => ({
  type: FETCH_QUESTION_FAILURE,
  payload: error,
});

// Create Question

export const createQuestion = (questionRequest) => ({
  type: CREATE_QUESTION,
  payload: questionRequest,
});

export const createQuestionSuccess = (question) => ({
  type: CREATE_QUESTION_SUCCESS,
  payload: question,
});

export const createQuestionFailure = (error) => ({
  type: CREATE_QUESTION_FAILURE,
  payload: error,
});

// Update Question

export const updateQuestion = ({ id, data }) => ({
  type: UPDATE_QUESTION,
  payload: { questionId: id, questionData: data },
});

export const updateQuestionSuccess = (question) => ({
  type: UPDATE_QUESTION_SUCCESS,
  payload: question,
});

export const updateQuestionFailure = (error) => ({
  type: UPDATE_QUESTION_FAILURE,
  payload: error,
});

// Delete Question

export const deleteQuestion = (questionId) => ({
  type: DELETE_QUESTION,
  payload: questionId,
});

export const deleteQuestionSuccess = (question) => ({
  type: DELETE_QUESTION_SUCCESS,
  payload: question,
});

export const deleteQuestionFailure = (error) => ({
  type: DELETE_QUESTION_FAILURE,
  payload: error,
});

// Upload Questions
export const uploadQuestions = (formDataRequest) => ({
  type: UPLOAD_QUESTIONS,
  payload: formDataRequest,
});

export const uploadQuestionsSuccess = (formData) => ({
  type: UPLOAD_QUESTIONS_SUCCESS,
  payload: formData,
});

export const uploadQuestionsFailure = (error) => ({
  type: UPLOAD_QUESTIONS_FAILURE,
  payload: error,
});

// Reset Question
export const resetQuestion = () => ({
  type: RESET_QUESTION,
});

export const countQuestions = () => ({
  type: COUNT_QUESTIONS,
});

export const countQuestionsSuccess = (count) => ({
  type: COUNT_QUESTIONS_SUCCESS,
  payload: count,
});

export const countQuestionsFailure = (error) => ({
  type: COUNT_QUESTIONS_FAILURE,
  payload: error,
});
